import React, { Component } from "react";
import "../../styles/legal_terms/legal_terms.css";

class AccessibilityStatement extends Component {
  render() {
    return (
        <div className="legal-terms-container">
            <article>
                <h1>Declaración de accesibilidad</h1>
                <p>
                    En NOI Donostia, nos esforzamos por garantizar que nuestro sitio web sea accesible para todos, incluidas las personas con discapacidades. Estamos comprometidos a cumplir con las pautas de accesibilidad web y a mejorar continuamente la experiencia de todos los usuarios.
                    Nuestro objetivo es proporcionar un sitio web que sea fácilmente navegable y usable para todos, independientemente de las capacidades individuales. Nos esforzamos por ofrecer un diseño y contenido que sean accesibles para usuarios de tecnologías de asistencia, como lectores de pantalla y navegadores de voz.
                    Si encuentra alguna barrera de accesibilidad en nuestro sitio web o tiene alguna sugerencia para mejorar la accesibilidad, no dude en contactarnos. Valoramos sus comentarios y estamos comprometidos a trabajar para resolver cualquier problema de accesibilidad que pueda surgir.
                    Gracias por visitar NOI Donostia y por su apoyo a nuestra misión de hacer que nuestro sitio web sea accesible para todos.
                    <br/>
                    Gracias por confiar en NOI Donostia.
                </p>
            </article>
        </div>
      );
  }
}

export default AccessibilityStatement;